
import Vue from 'vue'
import { VSimpleCheckbox } from 'vuetify/lib'

export default Vue.extend({
  name: 'JcdcCheckboxSimple',
  components: { VSimpleCheckbox },
  props: {
    check: { type: [Boolean, String], default: false },
    color: { type: String, default: 'primary' },
  },
  data() {
    return {
      checked: this.check,
    }
  },
  watch: {
    check() {
      this.checked = this.formatCheck(this.check)
    },
  },
  created() {
    this.checked = this.formatCheck(this.check)
  },
  methods: {
    formatCheck(check) {
      const type = typeof check
      if (type == 'string') {
        switch (check) {
          case 'Y':
            return true
          default:
            return false
        }
      } else {
        return check
      }
    },
  },
})
